import type { ComponentTheme } from '../types/component-theme';

import { BrFormFieldVariants } from './constants/br-form-field';

const labelStyles =
    'font-(family-name:--secondary-font) text-[0.75rem] font-bold uppercase tracking-[0.075em] ' +
    'text-(--text-field-label)';
const errorStyles = 'font-(family-name:--primary-font) text-[0.75rem] text-(--text-field-error)';

export default {
    slots: {
        label: '',
        error: ''
    },
    variants: {
        variant: {
            [BrFormFieldVariants.SoftInset]: {
                label: 'mb-1 pl-5 text-xs font-bold uppercase tracking-wider text-(--text-field-label)!',
                error: 'pl-5'
            },
            [BrFormFieldVariants.Neumorphic]: {
                label: `mb-[0.1rem] mt-[0.2rem] pl-[1.15rem] ${labelStyles}`,
                error: `pl-[1.15rem] ${errorStyles}`
            },
            [BrFormFieldVariants.Auth]: {
                label: `mb-3 pl-4 ${labelStyles}`,
                error: `pl-4 ${errorStyles}`
            }
        }
    }
} satisfies ComponentTheme;
